import * as React from "react";
import { cn } from "../../utils";
import { Label } from "../Label";

export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}

const Input = React.forwardRef<HTMLInputElement, InputProps>(
    ({ className, type, ...props }, ref) => {
        return (
            <input
                type={type}
                className={cn(
                    "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                    className,
                )}
                ref={ref}
                {...props}
            />
        );
    },
);
Input.displayName = "Input";
export interface FormInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
    label?: string;
    error?: string;
    required?: boolean;
}
const FormInput = React.forwardRef<HTMLInputElement, FormInputProps>(
    ({ label, error, required, id, className, ...props }, ref) => (
        <div className="grid gap-1.5">
            {label && (
                <Label htmlFor={id}>
                    {label}
                    {required && <span className="text-red-500 ml-0.5">*</span>}
                </Label>
            )}
            <Input
                id={id}
                ref={ref}
                aria-describedby={error && id ? `${id}-error` : undefined}
                className={cn(error && "border-red-500", className)}
                {...props}
            />
            {error && <p id={id ? `${id}-error` : undefined} className="text-sm text-red-500">{error}</p>}
        </div>
    ),
);
FormInput.displayName = "FormInput";

export { Input, FormInput };
